
import { GlobalClassInstance } from '@commoncore/constants/GlobalClass';
import { Controller } from '@commoncore/controller/Controller';
import { HomePageImplementation } from '@commoncore/implementation/HomePageImplementation';
import { GlobalService } from '@commoncore/services/global.service';
import { LocalStorageSvc } from '@commoncore/services/localStorage.service';
import { ENV_CONSTANTS } from '@env-properties/environment';
import { ENV_CONFIG } from '@env-properties/environment-config';
import { USER_DETAILS } from '../constants/Constants';

export class HomeController extends Controller{
    public homePageImplementation:any;
    public router:any;
    public http:any;
    public fetchFolderData:boolean=false;
    public static singleInstance:any = null;
    public universalService:any;
    loggerService: any
    localStorageSvc: LocalStorageSvc;
    listService:any;
    sessionStorageService: any;

    public constructor(private globalService:GlobalService) {
          super(globalService);
		  this.homePageImplementation= HomePageImplementation.getInstance(globalService);
    }
    
    public static getInstance(connectionService):HomeController{
		if(this.singleInstance == null){
			this.singleInstance = new HomeController(connectionService);
			return this.singleInstance;
		} else{
			return this.singleInstance;
		}
	}


    public setEnvObjects(globalService){
		this.universalService=globalService.getUniversalServiceRef();
		this.router = globalService.getRouterRef();
        this.http = globalService.getHttpClientRef();
        this.loggerService = globalService.getLoggerServiceRef();
        this.localStorageSvc = this.globalService.getLocalStorageSvcRef();
        this.sessionStorageService = this.globalService.getSessionStorageSvcRef();
        this.listService = this.globalService.getListServiceRef();
	}

  async fetchSummary(tab="") {
  
    this.universalService.showLoader = true;
    let summaryUrl;
    const currentFolderKey = this.sessionStorageService.getCurrentFolderkey(true);
    const rootFolderKey = USER_DETAILS["USER_DETAILS"]["rootFolderKey"];
    const privateFolderKey = this.localStorageSvc.getPrivateFolderKey();
    const currentPrivateFolderKey = this.sessionStorageService.getCurrentPrivateFolderKey(true) == false? "":this.sessionStorageService.getCurrentPrivateFolderKey(true);

    
    if(tab == 'privatefolder'){
        if( currentPrivateFolderKey!="" && currentPrivateFolderKey != privateFolderKey){
            await this.listService.getPPFToken();
            summaryUrl = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["nms"] + ENV_CONFIG.commonUrls["metaData"] + '/ppf/summary?folderKey='+currentPrivateFolderKey
            this.fetchFolderData = true; 
        }else if (currentPrivateFolderKey!="" && currentPrivateFolderKey == privateFolderKey) {
            await this.listService.getPPFToken();
            summaryUrl = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["nms"] + ENV_CONFIG.commonUrls["metaData"] + '/ppf/summary?folderKey=' 
            this.fetchFolderData = false;
        } 
    }

    else if (currentFolderKey && currentFolderKey != rootFolderKey) {
        summaryUrl = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["nms"] + ENV_CONFIG.commonUrls["metaData"] + '/summary?folderKey=' + currentFolderKey
        this.fetchFolderData = true;
    } 
    else {
        this.universalService.emptyFolder = false;
        this.fetchFolderData = false;
        summaryUrl= ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["nms"] + ENV_CONFIG.commonUrls["metaData"] + '/summary?folderKey='
    }
    return Promise.resolve(true); // to avoid summary call, we added a return
    try {
        let result = await this.homePageImplementation.fetchSummary(summaryUrl,this.fetchFolderData);
        this.loggerService.log("fetch summary result", result);
        return Promise.resolve(result);
    } catch(ex){
        console.log("summery call failed",ex)
        return Promise.reject(ex);
        
    }
}


setTabsStatusBasedOnData() {

  if (!this.localStorageSvc.getLocalProperty("imagesExists",true)) {
      var ele = document.getElementById("photos");
      ele.setAttribute('class', "no-data");
      this.redirectToAllFilesIfNoDataForRoute('photos')
  } else {
      var ele = document.getElementById("photos");
      ele.setAttribute('class', "");
     
  }
  if (!this.localStorageSvc.getLocalProperty("audiosExists",true)) {
      var ele = document.getElementById("audios");
      ele.setAttribute('class', "no-data")
      this.redirectToAllFilesIfNoDataForRoute('audio')
  } else {
      var ele = document.getElementById("audios");
      ele.setAttribute('class', "")
  }
  if (!this.localStorageSvc.getLocalProperty("videosExists",true)){
      var ele = document.getElementById("videos");
      ele.setAttribute('class', "no-data")
      this.redirectToAllFilesIfNoDataForRoute('videos')
  } else {
      var ele = document.getElementById("videos");
      ele.setAttribute('class', "")
  }
  if (!this.localStorageSvc.getLocalProperty("othersExists",true)) {
      var ele = document.getElementById("docs");
      ele.setAttribute('class', "no-data")
      this.redirectToAllFilesIfNoDataForRoute('docs')
  } else {
      var ele = document.getElementById("docs");
      ele.setAttribute('class', "")
  }
}


redirectToAllFilesIfNoDataForRoute(tabName){
  let currentRoute = this.router.url;
  let tab = tabName == 'docs' ? 'others' : tabName;
  if(currentRoute.includes(tabName) && !this.universalService.summaryData[tab])  {
    this.router.navigate(['/home']);
  }
}
        
}